export default __webpack_public_path__ + "static/media/bacqueville4.29622e1c.jpg";